import { FormField } from 'ui/formField';
import { useFormState } from 'react-hook-form';
import { InputField } from 'lib/iterable-hook-form';
import { NAME } from './ApiKeyModal.constants';
import { ApiKeysFormContextType } from '../contexts/ApiKeysFormProvider';

export const NameField = () => {
  const { errors } = useFormState<Pick<ApiKeysFormContextType, typeof NAME>>({
    name: [NAME],
  });
  const errorText = errors[NAME]?.message;
  return (
    <FormField
      inputId={NAME}
      labelText={'Name'}
      errorText={errorText}
      hasError={Boolean(errorText)}
    >
      <InputField id={NAME} name={NAME} data-test="api-key-name-field" autoFocus />
    </FormField>
  );
};
